const trackConversion = (email) => window.addEventListener('load', () => {
  window.gr('track', 'conversion', { email });
});

export default trackConversion;
